import { Stack } from '@mui/material';

import { locationArtLabels } from '../../../../utils/locationArtLabels';
import { TooltipElement } from '../../HoverCard';
import { isExperteResource, isGruppenraumResource, isSeminarraumResource, isStandortResource } from '../helperClasses';
import { type AbstractCalendarResource } from '../helperClasses/CalendarResource';
import { content } from './ResourceTooltip.content';

type ResourceTooltipProps = {
  readonly resource: AbstractCalendarResource;
  readonly year: number;
};

const printGruppenraumAnLocation = (hatGruppenraum: boolean | null): string => {
  if (hatGruppenraum === null) {
    return content.NO_INFO_AVAILABLE;
  }

  return hatGruppenraum ? content.VORHANDEN : content.NICHT_VORHANDEN;
};

export const ResourceTooltip = ({ resource, year }: ResourceTooltipProps) => {
  if (isSeminarraumResource(resource)) {
    const { location } = resource;

    return (
      <Stack gap={2} m={2}>
        <TooltipElement label={content.REGION} value={location.region?.name ?? content.NO_INFO_AVAILABLE} />
        <TooltipElement label={content.STANDORT} value={location.standort?.name ?? content.NO_INFO_AVAILABLE} />
        <TooltipElement label={content.LOCATION} value={location.name} />
        <TooltipElement
          label={content.ART}
          value={location.art ? locationArtLabels[location.art] : content.NO_INFO_AVAILABLE}
        />
        <TooltipElement label={content.GRUPPENRAUM} value={printGruppenraumAnLocation(location.hatGruppenraum)} />
        <TooltipElement label={content.KAPAZITAET} value="" />
        <TooltipElement
          label={content.U_FORM}
          value={resource.raum.kapazitaetUForm ?? content.NO_INFO_AVAILABLE}
          paddingLeft={2}
        />
        <TooltipElement
          label={content.PARLAMENTARISCH}
          value={resource.raum.kapazitaetParlamentarisch ?? content.NO_INFO_AVAILABLE}
          paddingLeft={2}
        />
        <TooltipElement
          label={content.OHNE_TISCH}
          value={resource.raum.kapazitaetOhneTische ?? content.NO_INFO_AVAILABLE}
          paddingLeft={2}
        />
      </Stack>
    );
  }

  if (isGruppenraumResource(resource)) {
    const { location } = resource;

    return (
      <Stack gap={2} m={2}>
        <TooltipElement label={content.REGION} value={location.region?.name ?? content.NO_INFO_AVAILABLE} />
        <TooltipElement label={content.STANDORT} value={location.standort?.name ?? content.NO_INFO_AVAILABLE} />
        <TooltipElement label={content.LOCATION} value={location.name} />
      </Stack>
    );
  }

  if (isStandortResource(resource)) {
    return (
      <Stack gap={2} m={2}>
        <TooltipElement label={content.STANDORT} value={resource.standort.name} />
      </Stack>
    );
  }

  if (isExperteResource(resource)) {
    const workloadSelectedYear = resource.experte.experteAuslastungen.find((wl) => wl.jahr === year);
    return (
      <Stack gap={2} m={2}>
        {workloadSelectedYear ? (
          <>
            <TooltipElement label={content.JAHR} value={workloadSelectedYear.jahr} />
            <TooltipElement label={content.GEBUCHTE_TAGE} value={Math.round(workloadSelectedYear.gebuchteTage)} />
            <TooltipElement label={content.VORGEMERKTE_TAGE} value={Math.round(workloadSelectedYear.vorgemerkteTage)} />
            <TooltipElement label={content.SUMME_TAGE} value={Math.round(workloadSelectedYear.summeTage)} />
            <TooltipElement label={content.SCHWELLE_GELB} value={workloadSelectedYear.schwelleGelb} />
            <TooltipElement label={content.SCHWELLE_ROT} value={workloadSelectedYear.schwelleRot} />
          </>
        ) : (
          <TooltipElement label={content.KEINE_AUSLASTUNGSDATEN} value="" />
        )}
      </Stack>
    );
  }

  return undefined;
};
